import styled from '@emotion/styled'
import { pxToRem } from 'utils/styled'

export const SWizardGridItemChild = styled.span`
  flex-grow: 1;
  text-align: left;
  margin-left: 10px;
  margin-right: 10px;

  display: block;
  align-items: center;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`

export const SWizardGridItemShare = styled.span`
  min-width: ${pxToRem(36)}rem;
  height: ${pxToRem(36)}rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  flex-shrink: 0;

  &:empty {
    display: none;
  }
`
